module.exports = function(){
    $(document).on('click', 'a[href*=\\#]:not([href=\\#]):not([role=tab])', function(event){
        var $anchor = $(this.hash);
        if ($anchor.length) {
            event.preventDefault();
            $('html,body').animate({scrollTop:$anchor.offset().top}, 500);
        }
    });
}();